import React from 'react';
import DOMPurify from "dompurify"; // XSS 공격을 방어하기 위한 라이브러리

function MessageConsultantSecond({text, btn1, btn2, btn1OnClick, btn2OnClick, isComplete}) {
  const sanitizedText = DOMPurify.sanitize(text);

    return (
      <div className="p-3 bg-[#F0F3F7] rounded-xl rounded-tl-[4px]">
        <p className="text-[15px] whitespace-pre-line" dangerouslySetInnerHTML={{ __html: sanitizedText }}></p>
        {
          !isComplete && (
            <>
            {
              btn1 && (
                <button className='bg-[#313A4C] w-full h-11 rounded-lg text-white mb-[10px] mt-4 text-[15px]' 
                  onClick={() => btn1OnClick(true)}
                >
                  {btn1}
                </button>
              )
            }
            {
              btn2 && (
                <button className='bg-[#fff] w-full h-11 rounded-lg text-[#313A4C] font-semibold text-[15px]' 
                  onClick={() => btn2OnClick(true)}
                >
                  {btn2}
                </button>
              )
            }
            </>
          )
        }
      </div>
    );
}

export default MessageConsultantSecond;